module.exports = __webpack_public_path__ + "img/carousel-wasa.png?8c9e96ea2c9b9ab5423e4178fa6a834c";